import { useEffect, useMemo, useState } from "react";
import { Option } from "../../../types/types";
import useApi from "../useApi";
import { master_baseUrl } from "../../webservice/Webservice_url";

interface dataTypes {
  project_id: string;
  project_code: string;
  project_name: string;
}

// projects by organization id
export function useProjectsByOrgId(orgId: string) {
  const [dataList, setDataList] = useState<dataTypes[]>([]);

  // API
  const { callApi, loading, error } = useApi<any>("", {
    method: "GET",
    autoCall: false,
    handleGlobalError: false,
  });

  const options = useMemo<Option[] | []>(() => {
    if (!dataList?.length) return [];

    return dataList?.map((d) => ({
      // label: d?.project_name ?? "",
      label:d?.project_name,
      value: d?.project_id ?? "",
    }));
  }, [dataList]);

  //   fetch data
  const fetchData = async () => {
    try {
      const res = await callApi(
        undefined,
        `${master_baseUrl}/organizations/${orgId}/projects`,
      );
      setDataList(Array.isArray(res) ? res : (res?.data ?? []));
    } catch (err: any) {
      setDataList([]);
      console.error(err);
    }
  };

  useEffect(() => {
    if (!orgId.length) {
      setDataList([]);
      return;
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  return { dataList, options, loading };
}

// projects by multiple organization id
export function useProjectsByMultiOrgId(orgId: string) {
  const [dataList, setDataList] = useState<dataTypes[]>([]);

  // API
  const { callApi, loading, error } = useApi<any>("", {
    method: "GET",
    autoCall: false,
    handleGlobalError: false,
  });

  const options = useMemo<Option[] | []>(() => {
    if (!dataList?.length) return [];

    return dataList?.map((d) => ({
      label: d?.project_name,
      value: d?.project_id ?? "",
    }));
  }, [dataList]);

  //   fetch data
  const fetchData = async () => {
    try {
      const res = await callApi(
        undefined,
        `${master_baseUrl}/organizations/${orgId}/projects`,
      );
      setDataList(Array.isArray(res) ? res : (res?.data ?? []));
    } catch (err: any) {
      setDataList([]);
      console.error(err);
    }
  };

  useEffect(() => {
    if (!orgId.length) {
      setDataList([]);
      return;
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  return { dataList, options, loading };
}
